import React, { RefCallback, ComponentPropsWithoutRef } from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { ColorValueStrict } from 'fronton-react';
import { useHrefConverter } from '../../hooks/use-href-converter';

type LinkStateProps = ComponentPropsWithoutRef<'a'> & {
  href: string;
};

type DivStateProps = ComponentPropsWithoutRef<'div'> & {
  href?: never; // Explicitly forbid href when acting as a div
};

export type LinkProps = {
  className?: string;
  children?: React.ReactNode;
  refCb?: RefCallback<HTMLAnchorElement>;
  title: string;
  bgcolor?: ColorValueStrict | string;
  hoverbgcolor?: ColorValueStrict | string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement> & (LinkStateProps | DivStateProps);

export const Link: React.FC<LinkProps> = ({ children, className, refCb, href, ...rest }) => {
  const linkHref = useHrefConverter(href);

  if (href) {
    return (
      <a
        className={cn(linkStyle, className)}
        data-testid="link"
        href={linkHref}
        {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
        ref={refCb}>
        {children}
      </a>
    );
  }

  return <div className={className}>{children}</div>;
}

export const linkStyle = css`
  display: block;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  color: inherit;

  &:focus {
    text-decoration: none;
  }

  &:hover {
    text-decoration: none;
  }
`;
